// extracted by mini-css-extract-plugin
export default {"productList":"Product_productList__1mIhd","loading":"Product_loading__CWUS9"};